import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

const domains = [
  { icon: 'ri-code-box-line', label: 'Développement logiciel' },
  { icon: 'ri-window-line', label: 'Création de sites web' },
  { icon: 'ri-settings-3-line', label: 'Solutions informatiques sur mesure' },
];

const values = [
  {
    icon: 'ri-shield-check-line',
    title: 'Fiabilité',
    description: 'Des solutions robustes testées et validées avant toute mise en production.',
  },
  {
    icon: 'ri-speed-line',
    title: 'Performance',
    description: 'Code optimisé pour des applications rapides et une expérience fluide.',
  },
  {
    icon: 'ri-user-heart-line',
    title: 'Écoute',
    description: "Chaque projet est unique. L'objectif est de comprendre précisément vos besoins.",
  },
  {
    icon: 'ri-refresh-line',
    title: 'Évolutivité',
    description: 'Des architectures pensées pour évoluer avec votre activité dans le temps.',
  },
];

export default function About() {
  return (
    <div className="min-h-screen bg-white font-[Manrope,sans-serif]">
      <Navbar />

      {/* Hero */}
      <section className="relative pt-40 pb-24 bg-[#0A1628] overflow-hidden">
        <div
          className="absolute inset-0 opacity-5"
          style={{
            backgroundImage:
              'linear-gradient(rgba(255,255,255,0.3) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.3) 1px, transparent 1px)',
            backgroundSize: '60px 60px',
          }}
        />
        <div className="relative z-10 max-w-5xl mx-auto px-6 lg:px-10 text-center">
          <span className="inline-block px-4 py-1.5 border border-white/20 rounded-full text-xs font-semibold tracking-widest uppercase text-white/50 mb-6">
            À propos
          </span>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
            Expertise au service<br />
            <span className="font-light text-white/60">de vos projets numériques</span>
          </h1>
          <p className="text-white/60 text-lg max-w-2xl mx-auto leading-relaxed">
            CICHORZ est une activité indépendante spécialisée dans la programmation informatique, basée à Paris.
          </p>
        </div>
      </section>

      {/* Story */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div className="relative">
              <div className="w-full h-96 rounded-2xl overflow-hidden">
                <img
                  src="https://public.readdy.ai/ai/img_res/e28d685700012b62ec192589aff4399a.jpg"
                  alt="Mariusz Slawomir Cichorz"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute -bottom-6 -right-6 bg-[#0A1628] rounded-2xl p-6 text-white">
                <p className="text-sm font-medium text-white/60 mb-1">Basé à</p>
                <p className="text-lg font-bold">Paris, France</p>
                <div className="flex items-center gap-2 mt-2">
                  <i className="ri-map-pin-line text-white/60 text-sm" />
                  <span className="text-sm text-white/60">75015 Paris</span>
                </div>
              </div>
            </div>

            <div>
              <span className="inline-block px-4 py-1.5 border border-gray-200 rounded-full text-xs font-semibold tracking-widest uppercase text-gray-500 mb-6">
                L&apos;entreprise
              </span>
              <h2 className="text-3xl md:text-4xl font-bold text-[#0A1628] mb-6 leading-tight">
                Mariusz Slawomir Cichorz
              </h2>
              <p className="text-[#374151] text-base leading-relaxed mb-6">
                CICHORZ est une activité indépendante dirigée par Mariusz Slawomir Cichorz, développeur
                expérimenté proposant des solutions techniques adaptées aux besoins des entreprises et des particuliers.
              </p>
              <p className="text-[#374151] text-base leading-relaxed mb-8">
                L&apos;objectif est de fournir des solutions fiables, modernes et adaptées à chaque projet,
                en combinant expertise technique et compréhension des enjeux métier.
              </p>

              {/* Domains */}
              <div className="flex flex-col gap-3">
                {domains.map((d) => (
                  <div key={d.label} className="flex items-center gap-4 p-4 bg-[#F7F8FA] rounded-xl">
                    <div className="w-9 h-9 flex items-center justify-center bg-[#0A1628] rounded-lg">
                      <i className={`${d.icon} text-white text-base`} />
                    </div>
                    <span className="text-[#0A1628] font-medium text-sm">{d.label}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-24 bg-[#F7F8FA]">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="text-center mb-16">
            <span className="inline-block px-4 py-1.5 border border-gray-300 rounded-full text-xs font-semibold tracking-widest uppercase text-gray-500 mb-6">
              Valeurs
            </span>
            <h2 className="text-4xl font-bold text-[#0A1628]">Ce qui guide chaque projet</h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {values.map((v) => (
              <div key={v.title} className="bg-white rounded-2xl p-8 text-center">
                <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4 rounded-xl bg-[#0A1628]">
                  <i className={`${v.icon} text-white text-xl`} />
                </div>
                <h3 className="text-[#0A1628] font-bold text-lg mb-2">{v.title}</h3>
                <p className="text-[#6B7280] text-sm leading-relaxed">{v.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Info entreprise */}
      <section className="py-24 bg-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-10">
          <div className="text-center mb-12">
            <span className="inline-block px-4 py-1.5 border border-gray-200 rounded-full text-xs font-semibold tracking-widest uppercase text-gray-500 mb-4">
              Informations légales
            </span>
            <h2 className="text-3xl font-bold text-[#0A1628]">Informations entreprise</h2>
          </div>
          <div className="bg-[#F7F8FA] rounded-2xl p-8 grid grid-cols-1 md:grid-cols-2 gap-6">
            {[
              { label: 'Nom commercial', value: 'CICHORZ' },
              { label: 'Dirigeant', value: 'Mariusz Slawomir Cichorz' },
              { label: 'Statut', value: 'Entrepreneur individuel' },
              { label: 'SIRET', value: '102 737 178 00016' },
              { label: 'Code APE', value: '62.01Z – Programmation informatique' },
              { label: 'Adresse', value: '57 Rue Lecourbe, 75015 Paris, France' },
              { label: 'Email', value: 'mariuszcichorz@inbox.eu' },
              { label: 'Téléphone', value: '+33 7 58 86 05 74' },
            ].map((item) => (
              <div key={item.label} className="flex flex-col gap-1">
                <span className="text-xs font-semibold tracking-widest uppercase text-[#6B7280]">{item.label}</span>
                <span className="text-[#0A1628] font-medium text-sm">{item.value}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-[#0A1628]">
        <div className="max-w-3xl mx-auto px-6 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">Discutons de votre projet</h2>
          <p className="text-white/60 mb-8">Contactez-nous pour une première échange gratuit et sans engagement.</p>
          <Link
            to="/contact"
            className="inline-flex items-center gap-3 px-8 py-4 bg-white text-[#0A1628] font-bold text-sm tracking-widest uppercase rounded-full hover:-translate-y-1 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            Nous contacter
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
